import React, { useCallback, useEffect, useState } from "react";
import { Alert, Button, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { hasAnyGeneralInventoryPermission } from "../../../config/permissionUtils";
import { useAuth } from "../../../context/AuthContext";
import { inventoryService } from "../../../services";

function ActiveGeneralInventoryAlert({ activeInventory: activeInventoryProp = null, sx = {} }) {
  const navigate = useNavigate();
  const { currentBranch, effectivePerms = [], isSuperuser } = useAuth();
  const branchId = currentBranch?.id || null;
  const [activeInventory, setActiveInventory] = useState(activeInventoryProp);
  const canOpenGeneral = hasAnyGeneralInventoryPermission(effectivePerms, isSuperuser);

  useEffect(() => {
    setActiveInventory(activeInventoryProp || null);
  }, [activeInventoryProp]);

  const loadActiveInventory = useCallback(async () => {
    if (!branchId || activeInventoryProp) return;
    try {
      const data = await inventoryService.getCountSettings({ branch_id: branchId });
      setActiveInventory(data?.active_general_inventory || null);
    } catch {
      setActiveInventory(null);
    }
  }, [activeInventoryProp, branchId]);

  useEffect(() => {
    loadActiveInventory();
  }, [loadActiveInventory]);

  if (!activeInventory?.id) return null;

  return (
    <Alert
      severity="warning"
      variant="outlined"
      action={
        canOpenGeneral ? (
          <Button
            color="inherit"
            size="small"
            onClick={() => {
              const status = String(activeInventory?.status || "").toUpperCase();
              const target =
                status === "DRAFT"
                  ? `/inventory/counts/general/capture?count_id=${activeInventory.id}`
                  : `/inventory/counts/${activeInventory.id}/review`;
              navigate(target);
            }}
            sx={{ whiteSpace: "nowrap" }}
          >
            Ver inventario
          </Button>
        ) : null
      }
      sx={{
        maxWidth: 920,
        py: 0.55,
        px: 1,
        borderRadius: 1,
        alignItems: "center",
        "& .MuiAlert-message": {
          py: 0.25,
          minWidth: 0,
        },
        ...sx,
      }}
    >
      <Stack spacing={0.15}>
        <Typography variant="body2" sx={{ fontWeight: 800 }}>
          Inventario general activo.
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Las operaciones de inventario y ventas estan temporalmente bloqueadas.
        </Typography>
      </Stack>
    </Alert>
  );
}

export default ActiveGeneralInventoryAlert;
